import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ImageryProviderService} from "../../services/imageryProvider/imagery-provider.service";

import {OverlayService} from "../../services/overlay/overlay.service";

@Component({
  selector: 'app-bw-toggler',
  templateUrl: './bw-toggler.component.html',
  styleUrls: ['./bw-toggler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BwTogglerComponent implements OnInit {
  public isDayTogglerChecked = false;
  constructor(protected provider: ImageryProviderService, protected cd:ChangeDetectorRef, private overlayService:OverlayService) { }

  ngOnInit() {}

  onDayTogglerChanged(val){
    // let name = null;
    // name = (val) ? 'B&W': null;
    this.provider.setCurrentViewModeGrayScale((val) ? 0 : 1);

    this.overlayService.setOverlaysGrayScale((val) ? 0 : 1);

  }
}
